import type { CalculatorMarket, CalculatorMatchSelection } from '@nowscore/core';
import { calculatorOptionGroups, calculatorSelectionLabel, MARKET_LABELS, OFFICIAL_MARKET_ORDER } from '@nowscore/core';
import type { MatchDto } from '../api';
import { latestLotteryQuotes } from '../lib/odds';

export function LotteryMarketTabs({ value, onChange, label = '官方竞彩玩法' }: { value: CalculatorMarket; onChange: (market: CalculatorMarket) => void; label?: string }) {
  return <nav className="lottery-market-tabs" role="tablist" aria-label={label}>{OFFICIAL_MARKET_ORDER.map((market) => <button key={market} type="button" role="tab" className={value === market ? 'active' : ''} aria-selected={value === market} onClick={() => onChange(market)}>{MARKET_LABELS[market]}</button>)}</nav>;
}

export function LotteryMarketGrid({ match, market, selection, onChange, compact = false }: { match: MatchDto; market: CalculatorMarket; selection?: CalculatorMatchSelection | null; onChange: (selection: CalculatorMatchSelection) => void; compact?: boolean }) {
  const quotes = latestLotteryQuotes(match, market).filter((quote) => quote.selection !== 'goalLine');
  const bySelection = new Map(quotes.map((quote) => [quote.selection, quote]));
  const activePick = selection?.picks.find((pick) => pick.market === market);
  const active = new Set(activePick?.selections ?? []);
  const line = quotes.find((quote) => quote.lineText)?.lineText;
  const toggle = (value: string) => {
    const picks = (selection?.picks ?? []).map((pick) => ({ market: pick.market, selections: [...pick.selections] }));
    const index = picks.findIndex((pick) => pick.market === market);
    if (index >= 0) {
      const next = picks[index]!.selections.includes(value)
        ? picks[index]!.selections.filter((item) => item !== value)
        : [...picks[index]!.selections, value];
      if (next.length > 0) picks[index] = { market, selections: next };
      else picks.splice(index, 1);
    } else {
      picks.push({ market, selections: [value] });
    }
    onChange({ scheduleId: match.scheduleId, picks });
  };
  return <section className={'lottery-market-grid-card market-' + market + (compact ? ' compact' : '')} aria-label={MARKET_LABELS[market] + ' 官方赛果'}>
    <header><b>{MARKET_LABELS[market]}</b>{line && <span>让球 {line}</span>}<small>{quotes.length > 0 ? quotes.length + ' 个赛果' : '未开售'}</small></header>
    {calculatorOptionGroups(market).map((group) => <div className="lottery-option-group" key={group.label}><span>{group.label}</span><div>{group.options.map((option) => {
      const quote = bySelection.get(option);
      const selected = active.has(option);
      return <button key={option} type="button" disabled={!quote || !(quote.odds > 1)} className={selected ? 'active' : ''} aria-pressed={selected} onClick={() => toggle(option)}><i>{calculatorSelectionLabel(market, option)}</i><b>{quote && quote.odds > 1 ? quote.odds.toFixed(2) : '未开售'}</b>{quote?.trend && <em>{quote.trend === 'up' ? '↑' : quote.trend === 'down' ? '↓' : ''}</em>}</button>;
    })}</div></div>)}
  </section>;
}